const copy = (() =>{
    const initBlock = el => {
        const textToCopy = el.dataset.copy;
        el.addEventListener("click", ()=> {
            navigator.clipboard.writeText(textToCopy).then(() => {
                alert("Link copied to clipboard!");
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        })
    }
    return {initBlock};
})();
ControlBinders.register(`[data-copy]`, el => copy.initBlock(el));